import { useQuery } from '@tanstack/react-query';
import { FileBarChart, FileSpreadsheet, Search } from 'lucide-react';
import { useState } from 'react';
import { api } from '@/lib/api';
import { Spinner, ErrorBox } from '@/ui/Spinner';
import { useWorkspace } from '@/shell/workspace';

interface Rep { id: number; code: string | null; name: string; group: string | null; description: string | null; excel: boolean; hasLayout: boolean }

/** Raporlar menüsü → grup altındaki raporların listesi (Delphi Form902) */
export function ReportGroupScreen({ group }: { group: string }) {
  const ws = useWorkspace();
  const [q, setQ] = useState('');
  const list = useQuery({ queryKey: ['reports', group], queryFn: () => api<Rep[]>(`/reports?group=${encodeURIComponent(group)}`) });
  if (list.isLoading) return <Spinner />;
  if (list.error) return <ErrorBox error={list.error} />;
  const items = (list.data ?? []).filter((r) => !q || r.name.toLocaleLowerCase('tr-TR').includes(q.toLocaleLowerCase('tr-TR')));
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 p-3">
      <div className="flex items-center gap-2">
        <div className="text-base font-semibold">{group} Raporları</div>
        <div className="relative ml-auto">
          <Search size={13} className="absolute left-2 top-[8px] muted" />
          <input className="inp !w-64 pl-7" placeholder="Rapor ara…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>
      <div className="grid min-h-0 flex-1 auto-rows-min gap-2 overflow-auto scroll-thin" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
        {items.map((r) => (
          <button key={r.id} className="panel flex items-start gap-3 rounded-md p-3 text-left hover:border-brand-500"
            onClick={() => ws.open({ kind: 'report', title: r.name, reportId: r.id })}>
            <span className="mt-0.5 text-brand-700">{r.hasLayout ? <FileBarChart size={18} /> : <FileSpreadsheet size={18} />}</span>
            <span className="min-w-0">
              <span className="block font-medium">{r.name}</span>
              <span className="block text-xs muted">{[r.code, r.description].filter(Boolean).join(' · ') || (r.hasLayout ? 'Yazdırılabilir rapor' : 'Liste raporu')}</span>
            </span>
          </button>
        ))}
        {!items.length && <div className="muted">Bu grupta yetkili olduğunuz rapor yok.</div>}
      </div>
    </div>
  );
}
